import styled from "styled-components";
import Welcome from "../../Login/Welcome/Components/Welcome";

function WelcomeAnimation(props) {
  return (
    <>
      <Wrapper>
        <div className="animation-div">
          <Welcome />
        </div>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  .animation-div {
    /* background-color: rgba(0, 0, 0, 0.5); */
    position: absolute;
    height: 100vh;
    width: 100vw;
    z-index: 20;
    top: 0;
  }
  background-color: #fff;
  box-sizing: border-box;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .content-inner {
    display: flex;
    align-self: flex-end;
    flex-direction: column;
    background-color: #f2f2f2;
    box-sizing: border-box;
    width: calc(100% - 88px);
    float: right;
    min-height: 100vh;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 63px);
    }
  }
`;
export default WelcomeAnimation;
